import { SearchBoosterEnrolledUsersParams, SearchBoosterProgramParams } from 'Modules'

export const boosterProgramKeys = {
  all: ['boosterPrograms'] as const,
  lists: () => [...boosterProgramKeys.all, 'list'] as const,
  list: (params: SearchBoosterProgramParams) => [...boosterProgramKeys.lists(), params] as const,
  details: () => [...boosterProgramKeys.all, 'detail'] as const,
  detail: (id: string | undefined) => [...boosterProgramKeys.details(), id] as const,
  stats: () => [...boosterProgramKeys.all, 'stats'] as const,
  overview: () => [...boosterProgramKeys.all, 'overview'] as const,
  enrolledLists: (programId: string | undefined) =>
    [...boosterProgramKeys.detail(programId), 'enrolled'] as const,
  enrolled: (programId: string | undefined, params: SearchBoosterEnrolledUsersParams) =>
    [...boosterProgramKeys.enrolledLists(programId), params] as const,
}
